import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ConfirmDialogComponent } from 'projects/shared/lib/components/shared/base/dialog/confirm-dialog/confirm-dialog.component';
import { IOverlayService, IOverlayServiceToken } from 'shared/services/ui/overlay/overlay-service.interface';

@Component({
  selector: 'app-age-confirm-dialog',
  templateUrl: './age-confirm-dialog.component.html',
  standalone: false
})
export class AgeConfirmDialogComponent extends ConfirmDialogComponent implements OnInit, OnDestroy {
  private readonly overlayService: IOverlayService = inject(IOverlayServiceToken);

  public ngOnInit(): void {
    this.overlayService.isOverlayVisibleSet(true);
  }

  public ngOnDestroy(): void {
    this.overlayService.isOverlayVisibleSet(false);
  }

}
